export default __webpack_public_path__ + "static/media/menuMirror.9ec31dc8.svg";